import React from 'react';
import * as S from './styles';

interface NavbarProps {
	children: React.ReactNode;
}

const Navbar = React.forwardRef<HTMLDivElement, NavbarProps>(({ children }, ref) => {
	return <S.Base ref={ref}>{children}</S.Base>;
});

Navbar.displayName = 'Navbar';

export default Navbar;
